import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAdminDetails,
  updateAdminDetails,
} from "../../redux/actions/authActions";
import { DashboardLayout } from "../../Pages/dashboard/DashboardLayout";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const AdminDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const {
    admin,
    isEditable,
    loading,
    error,
    updateLoading,
    updateError,
    updateSuccess,
  } = useSelector((state) => state.adminList);

  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    account_holder: "",
    account_number: "",
    bank_name: "",
    branch: "",
    ifsc_code: "",
    upi_id: "",
  });

  useEffect(() => {
    if (userInfo?.access_token) {
      dispatch(fetchAdminDetails(userInfo.access_token));
    }
  }, [dispatch, userInfo]);

  useEffect(() => {
    if (admin) {
      setFormData({
        account_holder: admin.account_holder || "",
        account_number: admin.account_number || "",
        bank_name: admin.bank_name || "",
        branch: admin.branch || "",
        ifsc_code: admin.ifsc_code || "",
        upi_id: admin.upi_id || "",
      });
    }
  }, [admin]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditToggle = () => setIsEditing(!isEditing);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!admin) return;
    dispatch(updateAdminDetails(admin.kyc_id, formData, userInfo.access_token));
    setIsEditing(false);
  };

  return (
    <DashboardLayout>
      <div className="">
        <div className="flex items-center space-x-3 py-4">
          <button onClick={() => navigate(-1)} className="hover:text-gray-800">
            <FaArrowLeft size={20} />
          </button>
          <h2 className="text-2xl font-bold text-amber-600 mb-1">
            Admin Payment Details
          </h2>
        </div>

        {loading && <p>Loading...</p>}
        {error && <p className="text-red-500">{error}</p>}
        {admin && (
          <div className="border rounded p-4 shadow bg-amber-50 border border-amber-500 space-y-2">
            {!isEditing ? (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 text-gray-800">
                  <p>
                    <span className="font-semibold text-gray-600">
                      Account Holder:
                    </span>{" "}
                    {admin.account_holder}
                  </p>
                  <p>
                    <span className="font-semibold text-gray-600">
                      Account Number:
                    </span>{" "}
                    {admin.account_number}
                  </p>
                  <p>
                    <span className="font-semibold text-gray-600">
                      Bank Name:
                    </span>{" "}
                    {admin.bank_name}
                  </p>
                  <p>
                    <span className="font-semibold text-gray-600">Branch:</span>{" "}
                    {admin.branch}
                  </p>
                  <p>
                    <span className="font-semibold text-gray-600">
                      IFSC Code:
                    </span>{" "}
                    {admin.ifsc_code}
                  </p>
                  <p>
                    <span className="font-semibold text-gray-600">UPI ID:</span>{" "}
                    {admin.upi_id}
                  </p>
                </div>

                {isEditable && (
                  <div className="mt-10 mb-10">
                    <button
                      className="mt-4 mb-4 px-6 py-2 bg-amber-500 text-gray-950 font-medium rounded shadow hover:bg-amber-500 text-gray-950 transition duration-200"
                      onClick={handleEditToggle}
                    >
                      Edit Details
                    </button>
                  </div>
                )}
              </>
            ) : (
              <form
                onSubmit={handleSubmit}
                className="max-w-full mx-auto p-2 rounded-lg  grid grid-cols-1 md:grid-cols-2 gap-2"
              >
                <h2 className="col-span-1 md:col-span-2 text-2xl font-bold text-amber-600 ">
                  Edit Admin Details
                </h2>

                {/* Account Holder */}
                <div>
                  <label
                    htmlFor="account_holder"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Account Holder
                  </label>
                  <input
                    id="account_holder"
                    name="account_holder"
                    type="text"
                    value={formData.account_holder}
                    onChange={handleInputChange}
                    className="w-full rounded-md border border-gray-300 px-4 py-2 text-gray-900 focus:border-indigo-500 focus:ring-indigo-500 focus:outline-none focus:ring-2 transition"
                    placeholder="Enter account holder name"
                    required
                  />
                </div>

                {/* Account Number */}
                <div>
                  <label
                    htmlFor="account_number"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Account Number
                  </label>
                  <input
                    id="account_number"
                    name="account_number"
                    type="text"
                    value={formData.account_number}
                    onChange={handleInputChange}
                    className="w-full rounded-md border border-gray-300 px-4 py-2 text-gray-900 focus:border-indigo-500 focus:ring-indigo-500 focus:outline-none focus:ring-2 transition"
                    placeholder="Enter account number"
                    required
                  />
                </div>

                {/* Bank Name */}
                <div>
                  <label
                    htmlFor="bank_name"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Bank Name
                  </label>
                  <input
                    id="bank_name"
                    name="bank_name"
                    type="text"
                    value={formData.bank_name}
                    onChange={handleInputChange}
                    className="w-full rounded-md border border-gray-300 px-4 py-2 text-gray-900 focus:border-indigo-500 focus:ring-indigo-500 focus:outline-none focus:ring-2 transition"
                    placeholder="Enter bank name"
                    required
                  />
                </div>

                {/* Branch */}
                <div>
                  <label
                    htmlFor="branch"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Branch
                  </label>
                  <input
                    id="branch"
                    name="branch"
                    type="text"
                    value={formData.branch}
                    onChange={handleInputChange}
                    className="w-full rounded-md border border-gray-300 px-4 py-2 text-gray-900 focus:border-indigo-500 focus:ring-indigo-500 focus:outline-none focus:ring-2 transition"
                    placeholder="Enter branch"
                    required
                  />
                </div>

                {/* IFSC Code */}
                <div>
                  <label
                    htmlFor="ifsc_code"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    IFSC Code
                  </label>
                  <input
                    id="ifsc_code"
                    name="ifsc_code"
                    type="text"
                    value={formData.ifsc_code}
                    onChange={handleInputChange}
                    className="w-full rounded-md border border-gray-300 px-4 py-2 text-gray-900 focus:border-indigo-500 focus:ring-indigo-500 focus:outline-none focus:ring-2 transition"
                    placeholder="Enter IFSC code"
                    required
                  />
                </div>

                {/* UPI ID */}
                <div>
                  <label
                    htmlFor="upi_id"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    UPI ID
                  </label>
                  <input
                    id="upi_id"
                    name="upi_id"
                    type="text"
                    value={formData.upi_id}
                    onChange={handleInputChange}
                    className="w-full rounded-md border border-gray-300 px-4 py-2 text-gray-900 focus:border-indigo-500 focus:ring-indigo-500 focus:outline-none focus:ring-2 transition"
                    placeholder="Enter UPI ID"
                    required
                  />
                </div>

                {/* Buttons: span full width */}
                <div className="mt-4 col-span-1 md:col-span-2 flex justify-end space-x-4">
                  <button
                    type="button"
                    onClick={handleEditToggle}
                    className="px-5 py-2 rounded-md border border-red-300 text-white bg-red-500 transition"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={updateLoading}
                    className="px-6 py-2 rounded-md bg-green-600 text-white font-semibold hover:bg-green-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {updateLoading ? "Saving..." : "Save Changes"}
                  </button>
                </div>

                {/* Error & Success Messages, full width */}
                {updateError && (
                  <p className="col-span-1 md:col-span-2 text-red-600 mt-2">
                    {updateError}
                  </p>
                )}
                {updateSuccess && (
                  <p className="col-span-1 md:col-span-2 text-green-600 mt-2">
                    Update successful!
                  </p>
                )}
              </form>
            )}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default AdminDetails;
